const routes = [
    {
        path: "/tyyc/level/outcomes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "tyycleveloutcome_index"
        }
    }
];

export default routes;